
import imageCompression from "browser-image-compression";

class FileService {
  async compressImage(file: File): Promise<File> {
    const options = {
      maxSizeMB: 1.8,
      maxWidthOrHeight: 1920,
      useWebWorker: true
    };
    let compressed: File | Blob = file;

    compressed = await imageCompression(file, options);

    if (compressed instanceof Blob && !(compressed instanceof File)) {
      return new File([compressed], file.name, {
        type: compressed.type,
        lastModified: Date.now()
      });
    }

    return compressed as File;
  }

  async readFileAsDataURL(file: File): Promise<string> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => resolve(reader.result as string);
      reader.onerror = reject;
      reader.readAsDataURL(file);
    });
  }
}

export default new FileService();
